import React from "react";
import { Button } from "@mui/material";

const AppButton = ({
  kind = "primary",
  className,
  sx,
  children,
  ...props
}) => {
  const variant = kind === "secondary" ? "outlined" : "contained";

  return (
    <Button
      variant={variant}
      color="primary"
      className={className}
      sx={{ minHeight: 36, ...sx }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default AppButton;
